// extracted by mini-css-extract-plugin
export default {"photo":"ProfilePhoto_photo__aP6BM"};